import { JSX } from 'react';
import { getRoute, useNavigate } from '../../routes';
import { Button, Heading, Layout, Link, Text } from '../core';
import { HeadingLevel } from '../core/Heading';

type EligibilityBlockerContentProps = {
  showReturnButton?: boolean;
  testIdPrefix?: string;
  headingLevel?: HeadingLevel;
};

export const EligibilityBlockerContent = ({
  showReturnButton = false,
  testIdPrefix = 'eligibility',
  headingLevel = 2,
}: EligibilityBlockerContentProps): JSX.Element => {
  const navigate = useNavigate();

  const onReturnHomePress = (): void => {
    navigate(getRoute('home', {}));
  };

  return (
    <Layout.VStack space={7}>
      <Layout.VStack space={5}>
        <Heading.h3 level={headingLevel}>
          Due to the termination of your previous Mantra care plan, we'll need to verify your
          eligibility to access therapy
        </Heading.h3>

        <Text.para>
          Please email our Care Navigation team at{' '}
          <Link.para to="mailto:hi@mantrahealth.com">hi@mantrahealth.com</Link.para> to see if you
          are eligible to continue with therapy.
        </Text.para>

        {showReturnButton && (
          <Button.secondaryLarge
            isLink
            testID={`${testIdPrefix}-return-home-button`}
            onPress={onReturnHomePress}
          >
            Return to Care Hub
          </Button.secondaryLarge>
        )}
      </Layout.VStack>
    </Layout.VStack>
  );
};
